export const NO_QUESTIONS_RESPONSE = {
    title: 'No questions found in the provided document',
    description: 'Please try with a different document',
};

export const FILE_UPLOAD_GENERIC_ERROR = {
    title: 'Something went wrong',
    description: 'Please check your files and try again',
};

export const STREAMING_RESPONSE_MESSAGES = [
    'I’m reviewing your request',
    'Finding the best info for you',
    'Preparing your response now',
];
